import React from "react";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FontQuicksand } from "../../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../../BuildingBlocks/FontSize";
import { FrontFontSizes } from "../../../../models/FrontFontSizes";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { TextColor } from "../../../BuildingBlocks/TextColor";
import { FrontColors } from "../../../../models/FrontColors";
import { Flex } from "../../../BuildingBlocks/Flex";
import { FrontLink } from "../../../FrontLink/FrontLink";
import { FPFooterLink } from "./FPFooterLink";
import { FPSimpleLogo } from "../FPSimpleLogo/FPSimpleLogo";

export const FPFooter = (): JSX.Element =>
    <SpacingColumn
        spacing="25px"
        justifyContent="center"
    >
        {/* LOGO */}
        <Flex justifyContent="center">
            <FPSimpleLogo width="62px"/>
        </Flex>

        {/* LINKS */}
        <Flex justifyContent="center">
            <FontQuicksand>
                <FontSize size={FrontFontSizes.MINOR}>
                    <TextColor color={FrontColors.NEUTRAL_18}>
                        <WeightMedium>
                            <FPFooterLink href="https://www.sailprobate.co.uk/compliance/privacy-policy">Privacy</FPFooterLink> |&nbsp;
                            <FPFooterLink href="https://blog.sailprobate.co.uk/terms-and-conditions/">T&Cs</FPFooterLink> |&nbsp;
                            <FPFooterLink href="https://www.sailprobate.co.uk/compliance/complaints-procedure">Complaints</FPFooterLink>
                        </WeightMedium>
                    </TextColor>
                </FontSize>
            </FontQuicksand>
        </Flex>
    </SpacingColumn>;
